


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import type { ImagemDaLeitura } from '@/shareds/novidades/modelo'

/**
 * Zoom das imagens da leitura: fechar (botão, Esc ou clique fora), anterior e próxima (botões e
 * setas do teclado). O ouvinte de teclado só existe enquanto o zoom está aberto.
 */
@Component
export default class VisualizadorDeImagem extends Vue {
	@Prop({ type: Array, required: true }) imagens!: ImagemDaLeitura[]
	/** Índice da imagem aberta; null fecha. */
	@Prop({ type: Number, default: null }) value!: number | null

	indice = 0
	focoAnterior: HTMLElement | null = null

	get imagem() {
		return this.value === null ? null : this.imagens[this.indice] || null
	}

	@Watch('value', { immediate: true })
	aoAbrirOuFechar(valor: number | null, anterior?: number | null) {
		if (valor === null) {
			this.desligarTeclado()
			if (anterior !== null && anterior !== undefined) this.devolverFoco()
			return
		}
		this.indice = valor
		if (anterior === null || anterior === undefined) {
			this.focoAnterior = document.activeElement as HTMLElement | null
			document.addEventListener('keydown', this.aoTeclar, true)
			this.$nextTick(() => {
				const botao = this.$refs.fechar as Vue | undefined
				if (botao) (botao.$el as HTMLElement).focus()
			})
		}
	}

	aoTeclar(evento: KeyboardEvent) {
		if (evento.key === 'Escape') this.fechar()
		else if (evento.key === 'ArrowLeft') this.ir(-1)
		else if (evento.key === 'ArrowRight') this.ir(1)
		else return
		evento.preventDefault()
		evento.stopPropagation()
	}

	ir(passo: number) {
		const novo = this.indice + passo
		if (novo < 0 || novo >= this.imagens.length) return
		this.indice = novo
		this.$emit('input', novo)
	}

	fechar() {
		this.$emit('input', null)
	}

	desligarTeclado() {
		document.removeEventListener('keydown', this.aoTeclar, true)
	}

	devolverFoco() {
		const alvo = this.focoAnterior
		this.focoAnterior = null
		if (alvo && document.body.contains(alvo)) setTimeout(() => alvo.focus({ preventScroll: true }), 0)
	}

	beforeDestroy() {
		this.desligarTeclado()
	}
}
